import React, { useState, useEffect } from "react"
import { Row, Col, Label, Input, Button, Spinner, Badge } from "reactstrap"
import Select from "react-select"
import Modal from "react-bootstrap/Modal"
import { withRouter, useParams, Link } from "react-router-dom"
import ButtonSpinner from "../../components/ButtonSpinner"
import { connect, useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"
// import { styles } from "./Input-Select/select"
import * as salesQcAction from "../../store/c2FsZXMgcWM/actions"
import * as salesAction from "../../store/c2FsZXM/actions"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import PropTypes from "prop-types"
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"

const SalesQc = (props) => {
  const { dispatch } = props

  let { id } = useParams()
  const empId = localStorage.getItem("empId")
  // console.log(id)
  const { SearchBar } = Search
  const specificDispatch = useDispatch()
  
  useEffect(() => {
    dispatch(salesQcAction.loadSalesPending(id))
    dispatch(salesQcAction.loadRecordsMetaData())
    dispatch(salesQcAction.loadSalesQcHistory(empId))
    dispatch(salesAction.loadEmployee())
  }, [])

  //States for all the actions
  const [salesData, setSalesData] = useState({
    quotationFromDate: "",
    quotationToDate: "",
  })

  const handleChange = (e) => {
    setSalesData({ ...salesData, [e.target.name]: e.target.value })
  }

  const [btnLoader, setBtnLoader] = useState(false)
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [priority, setPriority] = useState([])
  const [service, setService] = useState([])
  const [approvalView, setApprovalView] = useState(false)
  const handleApprovalClose = () => setApprovalView(false)

  ///Sales Approval Store and data table

  const salesQcUpdate = useSelector((specificState) => specificState.salesQc)
  const salesUpdate = useSelector((specificState) => specificState.sales)
  const sessionUpdate = useSelector((specificState) => specificState.session)

  const {
    sales_pending_details = [],
    salesQcMetaData = {},
    // sales_qc_history = [],
  } = salesQcUpdate

  const { employee_list = [] } = salesUpdate

  const { user = [] } = sessionUpdate

  const managerId = !isEmpty(user) && user.roleId

  // console.log(managerId, sales_qc_history, "managerId details")

  const salesDetails = sales_pending_details
  //Date format

  const dateSetting =
  !isEmpty(user) && user.setting && user.setting.dateFormate
    ? user.setting.dateFormate.toUpperCase()
    : []
  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  //Dropdown list ffrom Api
  const branchOptions =
    !isEmpty(salesQcMetaData) &&
    salesQcMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )

  const serviceOptions =
    !isEmpty(salesQcMetaData) &&
    salesQcMetaData.serviceOptions.filter(
      (service) => service.companyId && service.companyId[0] === company.value
    )

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)

  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  let slNo = 0
  const salesDataTable = !isEmpty(salesDetails)
    ? salesDetails.map((sales, index) => {
        const salesDetail =
          !isEmpty(sales) && sales.salesDetail ? sales.salesDetail[0] : []
        slNo = slNo + 1
        var salesDate = !isEmpty(salesDetail.salesDate)
          ? moment(salesDetail.salesDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(dateFormate)
          : []
        return {
          _id: sales._id,
          sNo: slNo,
          action: (
            <Button
              type="submit"
              style={{ fontSize: "8px" }}
              // onClick={() => {
              //   editSalesApproval(sales)
              // }}
              className="btn btn-success"
            >
              <i className="fas fa-edit icon-btn"></i>
            </Button>
          ),
          leadQuotationId: sales.leadQuotationId,
          leadId: sales.leadId,
          salesNo: (
            <Link
              to={{
                pathname: `/client-details/${sales.leadId}`,
                state: { sales },
                id: { managerId },
              }}
              onClick={() => editQcApprove()}
              style={{ textTransform: "uppercase" }}
            >
              {salesDetail.salesNo}
            </Link>
          ),
          salesDate: salesDate,
          mode: sales.mode,
          billingAddress: salesDetail.billingAddress1,
          billingAddress1: salesDetail.billingAddress2,
          withTaxedAmount: salesDetail.withTaxedAmount,
          withoutTaxedAmount: salesDetail.withoutTaxedAmount,
          totalAmount: salesDetail.totalAmount,
          paymentMode: salesDetail.advanceDetail.paymentModeName,
          qcStatus: (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                sales.qcStatus === "pending"
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
              }`}
              pill
              style={{ cursor: "pointer" }}
              onClick={() => setApprovalView(true)}
            >
              {sales.qcStatus === "pending" ? "Pending" : "Approved"}
            </Badge>
          ),
          key: index,
        }
      })
    : []

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "action",
      text: "Action",
    },
    {
      dataField: "salesNo",
      text: "Sales No",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
    {
      dataField: "salesDate",
      text: "Sales Date",
      headerStyle: {
        minWidth: "140px",
      },
      sort: true,
    },
    {
      dataField: "mode",
      text: "Mode",
      headerStyle: {
        minWidth: "130px",
      },
      sort: true,
    },
    {
      dataField: "billingAddress",
      text: "Billing Address",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "billingAddress",
      text: "Billing Address1",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "withTaxedAmount",
      text: "WithTax",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "withoutTaxedAmount",
      text: "WithoutTax",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "totalAmount",
      text: "Total Amount",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "paymentMode",
      text: "Payment Mode",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
    {
      dataField: "qcStatus",
      text: "Quotation Status",
      headerStyle: {
        minWidth: "160px",
      },
      sort: true,
    },
  ]

  //Page Navigation to quotation-details
  const [isLoading, setIsLoading] = useState(false)

  //Options base on company details

  const handleCompanyChange = (e) => {
    setCompany(e)

    var dataSales = salesData
    dataSales.quotationFromDate = e ? "" : salesData.quotationFromDate
    dataSales.quotationToDate = e ? "" : salesData.quotationToDate
    setBranch([])
    setService([])
    setPriority([])
    setSalesAgent([])
  }
  // console.log(priority, "priority")

  const editQcApprove = () => {
    setIsLoading(true)
  }

  const [salesAgent, setSalesAgent] = useState([])

  const handleApply = () => {
    setBtnLoader(true)
    var searchCompany = company && company.value ? [company.value] : ""
    var searchBranch = branch && branch.value ? [branch.value] : ""
    var searchService = service && service.value ? [service.value] : ""
    var searchEmpCode =
      salesAgent && salesAgent.empCode ? salesAgent.empCode : ""
    var searchPriority = priority && priority.value ? [priority.value] : ""

    var searchFromDate =
      salesData && salesData.quotationFromDate
        ? salesData.quotationFromDate
        : ""
    var searchToDate =
      salesData && salesData.quotationToDate ? salesData.quotationToDate : ""

    var searchValue = {}
    if (searchCompany) {
      searchValue.company = searchCompany
    }
    if (searchBranch) {
      searchValue.branch = searchBranch
    }
    if (searchService) {
      searchValue.service = searchService
    }
    if (searchPriority) {
      searchValue.priority = searchPriority
    }
    if (searchEmpCode) {
      searchValue.empCode = searchEmpCode
    }
    if (searchFromDate) {
      searchValue.startDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.endDate = searchToDate
    }

    // console.log("searchCompany", searchValue)
    specificDispatch(salesQcAction.loadSalesPending(searchValue))
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  // const editSalesApproval = () => {}
  const title = "Sales QC"
  return (
    <React.Fragment>
      <div className="sales-approval">
        <Row>
          {/* Sales approval Head */}
          <Col xl="12" lg="12" md="12" sm="12" xs="12">
            <Row>
              <Col xl="12" md="12" lg="12" sm="12" xs="12">
                <MetaTags>
                  <title>{title} | Zero Gravity CRM</title>
                </MetaTags>
                {/* Render Breadcrumb */}
                <Breadcrumbs title={"Approvals"} breadcrumbItem={title} />
                {/* <div className="sales-head">
                  <h1 className="sales-approval-head">SALES QC</h1>
                  <h1 className="sales-approval-sub-head">
                    Approval / Sales QC
                  </h1>
                </div> */}
              </Col>
              <Col
                xl="12"
                md="12"
                lg="12"
                sm="12"
                xs="12"
                className="sales-approval-card"
              >
                <Row className="sales-approval-form">
                  <Col className="mt-2 mb-2">
                    <Row className="">
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Company</Label>
                        <Select
                          name="company"
                          // isMulti
                          value={company}
                          onChange={(e) => handleCompanyChange(e)}
                          options={
                            salesQcMetaData
                              ? salesQcMetaData.companyOptions
                              : ""
                          }
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Branch</Label>
                        <Select
                          name="branch"
                          value={branch}
                          onChange={(e) => setBranch(e)}
                          options={branchOptions}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Service</Label>
                        <Select
                          name="service"
                          value={service}
                          onChange={(e) => setService(e)}
                          options={serviceOptions}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Priority</Label>
                        <Select
                          name="priority"
                          value={priority}
                          onChange={(e) => setPriority(e)}
                          options={
                            salesQcMetaData
                              ? salesQcMetaData.priorityOptions
                              : ""
                          }
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Sales Agent</Label>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          items={agentOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">
                          Quotation From Date
                        </Label>
                        <Input
                          type="date"
                          name="quotationFromDate"
                          value={salesData.quotationFromDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Select Date"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className="event-label">Quotation To Date</Label>
                        <Input
                          type="date"
                          name="quotationToDate"
                          value={salesData.quotationToDate}
                          onChange={(e) => handleChange(e)}
                          placeholder="Select Date"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xl="12"
                    lg="12"
                    md="12"
                    //   className="sales-approval-filter"
                  >
                    <button
                      type="button"
                      className="btn btn-success btn-label form-submit-btn sales-approval-filter"
                      onClick={() => handleApply()}
                    >
                      <i
                        className="fas fa-check-double label-icon"
                        style={{ fontSize: "12px" }}
                      ></i>
                      {btnLoader && btnLoader ? (
                        <ButtonSpinner />
                      ) : (
                        "Apply Filter"
                      )}{" "}
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col className="sales-approval-card mt-3">
            <Row className="sales-approval-form">
              <Col className="h-100 mt-3 mb-3">
                <ToolkitProvider
                  keyField="_id"
                  data={salesDataTable}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <div>
                      <Col md="12" xl="12" lg="12" sm="12" xs="12">
                        <Row className="d-flex flex-column">
                          <Col className="mb-3">
                            <SearchBar {...props.searchProps} />
                          </Col>
                          <Col>
                            <BootstrapTable
                              // keyField="_id"
                              // data={leaveDataTable}
                              // columns={columns}
                              {...props.baseProps}
                              responsive
                              pagination={paginationFactory()}
                              striped={true}
                              bordered={true}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </div>
                  )}
                </ToolkitProvider>
                {approvalView && (
                  <Modal show={approvalView} onHide={handleApprovalClose}>
                    <Modal.Header>Sales QC request</Modal.Header>
                    <Modal.Body>
                      Are you sure you want to approve the sales QC ?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="btn btn-danger"
                        onClick={handleApprovalClose}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        className="btn btn-success"
                        onClick={() => {
                          handleApprovalClose()
                        }}
                      >
                        Accept
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                {isLoading ? (
                  <Modal
                    show={isLoading}
                    style={{ width: "10%", margin: "20% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                      />
                      <span>Loading...</span>
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

SalesQc.propTypes = {
  dispatch: PropTypes.func,
  sales_pending_details: PropTypes.array,
  sales_qc_history: PropTypes.array,
  employee_list: PropTypes.array,
  recordsMetaData: PropTypes.object,
  salesQcMetaData: PropTypes.object,
  records: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
}

const mapStateToProps = (state) => ({
  sales_pending_details: state.quotation.sales_details,
  employee_list: state.quotation.employee_list,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SalesQc))
